import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from "@/components/ui/sidebar";
import { FrontendRoute } from "../frontend-routes";

export const NavSecondary = ({
    items,
    ...props
}: {
    items: readonly FrontendRoute[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) => {
    const { isMobile, setOpenMobile } = useSidebar();

    const handleClick = (item: FrontendRoute) => {
        if (isMobile) setOpenMobile(false);
        item.onClick?.();
    };

    return (
        <SidebarGroup {...props}>
            <SidebarGroupContent>
                <SidebarMenu>
                    {items.map((item) => (
                        <SidebarMenuItem key={item.name}>
                            {item.onClick ? (
                                <SidebarMenuButton
                                    size="sm"
                                    onClick={() => handleClick(item)}
                                >
                                    <item.icon />
                                    <span>{item.name}</span>
                                </SidebarMenuButton>
                            ) : (
                                <SidebarMenuButton size="sm">
                                    <a
                                        href={item.href}
                                        target={
                                            item.isExternal
                                                ? "_blank"
                                                : undefined
                                        }
                                        className="flex flex-1 gap-2"
                                    >
                                        <item.icon />
                                        <span>{item.name}</span>
                                    </a>
                                </SidebarMenuButton>
                            )}
                        </SidebarMenuItem>
                    ))}
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    );
};
